export { API_ND_AREA } from '../constants';
export const CRUMB_LABEL_KEY = 'CustomerPendingEnquiries';
export const NAME = 'CustomerPendingEnquiries';
